import React from "react";
import { Link } from "react-router-dom";
import { routes } from "@/lib/constants";
import { getHomeRouteForUser } from "@/lib/routing";
import styles from "@/styles/layout.module.css";
import { layoutBackgrounds } from "@/assets";
import { inter, philosopher } from "@/lib/fonts";
import { useAuth } from "@/contexts/AuthContext";

export default function NotFound() {
  const { data: session } = useAuth();
  const homepageLink = session
    ? getHomeRouteForUser(session.user)
    : routes.landing;

  return (
    <div
      className={`${styles.homeLayout} ${philosopher.className} flex flex-col items-center justify-center min-h-screen p-4 bg-gray-50`}
      style={layoutBackgrounds.home}
    >
      <h1
        className={
          "uppercase text-6xl text-primary font-medium pb-7 text-center"
        }
      >
        404
      </h1>
      <h2 className="text-2xl font-semibold mb-4 text-center">
        Page Not Found
      </h2>
      <p className={`text-center mb-8 px-4 ${inter.className}`}>
        Sorry, the page you are looking for does not exist.
      </p>
      <Link
        to={homepageLink}
        className="px-6 py-3 bg-primary text-white rounded-md hover:bg-primary-dark transition"
      >
        Go to Homepage
      </Link>
    </div>
  );
}
